export interface NotBuiltYetProps {
  title: string;
  /** Where this screen sits in the build order, so the placeholder is honest. */
  step: string;
  items: string[];
}

export function NotBuiltYet({ title, step, items }: NotBuiltYetProps) {
  return (
    <section className="rounded-lg border border-line bg-surface p-5">
      <h1 className="text-xl font-semibold">{title}</h1>
      {step ? <p className="mt-1 text-sm text-ink-soft">{step}. Not built yet.</p> : null}
      <ul className="mt-4 space-y-1 text-sm">
        {items.map((item) => (
          <li key={item} className="flex gap-2">
            <span aria-hidden="true">&bull;</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
